import * as XLSX from 'xlsx';
import { FileResultType } from '../../../Helper/file';
import { BulkAWBType } from './types';

export const readXslAndGetBulkAWBUploadObject = (data: FileResultType[]): BulkAWBType[] => {
  if (!data?.length) {
    throw { msg: 'Please upload AWB sheet.' };
  }

  const file = data[0];

  // Check if fileData exists
  if (!file.fileData || !(file.fileData instanceof Array) || file.fileData.length === 0) {
    throw { msg: 'File data is missing' };
  }

  const sheetData = file.fileData[0];

  // Convert the array data into a worksheet
  const worksheetData = sheetData.data;

  if (!worksheetData || worksheetData.length < 2) {
    throw { msg: 'Sheet is empty or has no data rows.' };
  }

  // Extract headers (first row)
  const headers = worksheetData[0];
  console.info('Headers:', headers);

  // Create worksheet object
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Convert to JSON
  const jsonData: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });

  if (!jsonData.length) {
    throw { msg: 'Sheet is empty.' };
  }

  const shipmentSet = new Set<string>();
  const parsedData: BulkAWBType[] = [];

  jsonData.forEach((row, index) => {
    const shipmentNumber = row['Shipment Number']?.toString().trim();
    const AWBNumber = row['AWB Number']?.toString().trim();

    if (!shipmentNumber || !AWBNumber) {
      throw {
        msg: `Shipment Number / AWB Number missing at row ${index + 2}`,
      };
    }

    // Duplicate check
    if (shipmentSet.has(shipmentNumber)) {
      throw {
        msg: `Duplicate Shipment Number found: ${shipmentNumber}`,
      };
    }

    shipmentSet.add(shipmentNumber);
    parsedData.push({
      shipmentNumber,
      AWBNumber,
    });
  });

  return parsedData;
};
